import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import QuestionPreview from "../QuestionPreview";
import useStyles from "./styles";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";
import { getTranslation } from "../../../locales";

const VALUE_PREFIX = "Value_";

const AnswerDropDown = (props) => {
  const { t } = useTranslation("surveyTaker");

  const [selected, setSelected] = React.useState(props.value);
  const { currentTheme } = useSelector((state) => state.survey);
  const styles = useStyles({ ...props, currentTheme });

  const handleChange = (event, option) => {
    if (option) {
      setSelected(option.value);
      props.handleChange(option.value);
    }
    event.preventDefault();
  };

  useEffect(() => {
    const newSelectedValue = props.value
      ? `${VALUE_PREFIX}${props.value}`
      : getTranslation(props.currentLang, "surveyTaker:pleaseSelect");
    setSelected(newSelectedValue);
  }, [props.value, props.choices]);

  const getChoices = () => {
    if (props.choices) {
      return props.choices
        .filter((item) => item.shouldRenderChoice !== false)
        .map((item) => {
          if (!item.value.includes(VALUE_PREFIX)) {
            item.value = `${VALUE_PREFIX}${item.value}`;
          }
          return item;
        });
      // if (
      //   selected &&
      //   selected != t("surveyTaker:pleaseSelect") &&
      //   transformedChoices.filter((choice) => choice.value === selected)
      //     .length === 0
      // ) {
      //   setSelected(t("surveyTaker:pleaseSelect"), () => props.handleChange);
      // }
    }
    return [];
  };

  return (
    <div>
      <fieldset>
        {!props.ptl && (
          <legend>
            <QuestionPreview
              question={props.question || t("surveyTaker:dropdownQuestion")}
              required={props.required}
              helperText={props.helperText}
              formattingType={
                props.formattingType ? props.formattingType : null
              }
            />
          </legend>
        )}
        <Autocomplete
          id={props.questionId}
          disableClearable
          options={getChoices()}
          value={
            getChoices()?.find((option) => option.value === selected) || ""
          }
          // getOptionLabel={(option) => option.label}
          style={{ selectMenu: styles.selectMenu }}
          onChange={handleChange}
          // renderOption={(option) => (
          //   <div className={styles.label}>{option?.label}</div>
          // )}
          renderInput={(params) => (
            <TextField
              {...params}
              label={
                !props.formattingType
                  ? getTranslation(
                      props.currentLang,
                      "surveyTaker:pleaseSelect"
                    )
                  : getTranslation("en", "surveyTaker:pleaseSelect")
              }
              variant="outlined"
            />
          )}
          data-testid="dropdown-autocomplete"
        />
      </fieldset>
    </div>
  );
};

AnswerDropDown.defaultProps = {
  choices: [],
  handleChange: () => {},
  required: false,
};

AnswerDropDown.propTypes = {
  choices: PropTypes.array.isRequired,
  question: PropTypes.string.isRequired,
  handleChange: PropTypes.func,
  required: PropTypes.bool.isRequired,
};

export default AnswerDropDown;
